import React from 'react';
import styled from 'styled-components';
import { Box, Flex } from 'rebass';
import { Card, Divider } from 'semantic-ui-react';

import { Text } from '../Base';
import { COLOR, FONT_SIZE, SPACE } from '../Theme';

const StyledCard = styled(Card)`
  &.ui.card {
    border-radius: 8px;
    width: 100%;
  }
`;

const Link = styled(Text)`
  cursor: pointer;
  position: absolute;
  right: 16px;
  top: 16px;
  &:hover {
    color: ${COLOR.primary};
    text-decoration: underline;
  }
`;
const MockExamDataCard = ({
  disabledDivider,
  ModalLink,
  linkText,
  headText,
  onClickLink,
  children,
}) => {
  return (
    <StyledCard>
      {ModalLink ? (
        <Link>{ModalLink}</Link>
      ) : (
        <Link is="a" color="primary" onClick={onClickLink}>
          {linkText}
        </Link>
      )}
      <Flex flexDirection="column" flex={1} p={SPACE.large}>
        <Text fontWeight={500} fontSize={FONT_SIZE.large}>
          {headText}
        </Text>
        {disabledDivider || <Divider />}
        {children}
      </Flex>
    </StyledCard>
  );
};

export default MockExamDataCard;
